const SIGNUP = 'my-account/create/signup';
const SIGNUP_SUCCESS = 'my-account/create/sign-success';
const SIGNUP_FAILED = 'my-account/create/signup-failed';
const SET_PASSWORD = 'my-account/create/set-password';
const SET_PASSWORD_SUCCESS = 'my-account/create/set-password-success';
const SET_PASSWORD_FAILED = 'my-account/create/set-password-failed';
const signup = (payload)=>({
        type: SIGNUP,
        payload
    })
;
const signUpSuccess = (payload)=>({
        type: SIGNUP_SUCCESS,
        payload
    })
;
const signUpFailed = (error)=>({
        type: SIGNUP_FAILED,
        error
    })
;
const setPassword = (payload)=>({
        type: SET_PASSWORD,
        payload
    })
;
const setPasswordSuccess = (payload)=>({
        type: SET_PASSWORD_SUCCESS,
        payload
    })
;
const setPasswordFailed = (error)=>({
        type: SET_PASSWORD_FAILED,
        error
    })
;

export { SET_PASSWORD, SET_PASSWORD_FAILED, SET_PASSWORD_SUCCESS, SIGNUP, SIGNUP_FAILED, SIGNUP_SUCCESS, setPassword, setPasswordFailed, setPasswordSuccess, signUpFailed, signUpSuccess, signup };
//# sourceMappingURL=actions.js.map
